import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two my-tasks" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = {
  class: "fw-medium fs-14 position-relative top-0 ms-2",
  for: "flexCheckDefault2"
}
const _hoisted_8 = { class: "p-4 pt-lg-4" }
const _hoisted_9 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_10 = { class: "fs-12 fw-medium" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "fs-12 fw-medium me-2" }
const _hoisted_13 = { "aria-label": "Page navigation example" }
const _hoisted_14 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_15 = { class: "page-item" }
const _hoisted_16 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">My Tasks</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>All Tasks</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault"
                    }),
                    _createElementVNode("label", {
                      class: "position-relative top-2 ms-2",
                      for: "flexCheckDefault"
                    }, " Project Name ")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Deadline"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[2] || (_cache[2] = _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      }, null, -1)),
                      _createElementVNode("label", _hoisted_7, _toDisplayString(item.projectName), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.deadline), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, " Items per pages: " + _toDisplayString(_ctx.itemsPerPage), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.startItem) + " - " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.totalItems), 1),
              _createElementVNode("nav", _hoisted_13, [
                _createElementVNode("ul", _hoisted_14, [
                  _createElementVNode("li", _hoisted_15, [
                    _createElementVNode("a", {
                      class: "page-link icon",
                      href: "#",
                      "aria-label": "Previous",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                    ]))])
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("a", {
                      class: "page-link icon",
                      href: "#",
                      "aria-label": "Next",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}